import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";
import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/basecamp")({
  component: BasecampRoute,
  beforeLoad() {
    ensureSession();
  },
});

function BasecampRoute() {
  return (
    <PermissionGuard permission="studio-edits:view">
      <Outlet />
    </PermissionGuard>
  );
}
